import React from "react";
import { useLocation } from "react-router-dom";
import "./eligibility-flow.scss";
import EligibilityFlowHeader from "./EligibilityFlowHeader";
import { Outlet } from "react-router-dom";
import EligibilityFlowLeftContainer from "./EligibilityFlowLeftContainer";
import TopNavbar from "./TopNavbar";

const routeProgressMap = {
  "": { percentage: 25, step: "STEP 1 OF 4" },
  "gp-details": { percentage: 25, step: "STEP 1 OF 4" },
  condition: { percentage: 50, step: "STEP 2 OF 4" },
  age: { percentage: 75, step: "STEP 3 OF 4" },
  "eligibility-success": { percentage: 100, step: "STEP 4 OF 4" },
  "eligibility-error": { percentage: 100, step: "STEP 4 OF 4" },
  "eligibility-age-error": { percentage: 100, step: "STEP 4 OF 4" },
  callback: { percentage: 100, step: "STEP 2 OF 2" },
  "personal-details": { percentage: 33.3, step: "STEP 1 OF 3" },
  "order-confirm": { percentage: 50, step: "STEP 1 OF 2" },
  "order-success": { percentage: 100, step: "STEP 2 OF 2" },
  "additional-info": { percentage: 50, step: "STEP 2 OF 4" },
  "id-upload": { percentage: 75, step: "STEP 3 OF 4" },
  "kyc-document": { percentage: 100, step: "STEP 4 OF 4" },
};

const EligibilityFlowLayout = () => {
  const location = useLocation();
  const currentPath =
    location.pathname.split("/onboarding/eligibility-flow/")[1] || "";

  const progressData = routeProgressMap[currentPath] || {
    percentage: 0,
    step: "STEP 1 OF 4",
  };

  return (
    <div>
      <div className="d-md-none w-100">
        <TopNavbar />
      </div>
      <div className="container container-div">
        <div className="row justify-content-between gx-0">
          <div
            className={`col-md-5 col-lg-4 col-xl-4 d-none d-md-block left-container-index ${
              currentPath === "personal-details" ? "left-container" : ""
            }`}
          >
            <EligibilityFlowLeftContainer currentPath={currentPath} />
          </div>

          <div className="col-md-7 col-lg-8 col-xl-7 d-flex flex-column ps-md-4 ps-lg-6 ps-xl-0">
            <EligibilityFlowHeader
              percentage={progressData.percentage}
              step={progressData.step}
              currentPath={currentPath}
              navbar={false}
            />
            <div className="col-md-12 px-3 mt-4 mt-md-5 mb-10 mb-md-0 flex-grow-1">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EligibilityFlowLayout;
